import { IMG_BASE_URL } from "constants";
import { VideoWrapper } from "./VideoPreview.style";

export default function VideoContainer(props) {
  return (
    <VideoWrapper width={props.width} height={props.height} {...props}>
      <video
        src={props.isWeb ? IMG_BASE_URL + props.src : props.src}
        controls
        style={{ height: "100%" }}
      />
    </VideoWrapper>
  );
}
